import { ProductSelectDataState } from 'types/productTypes';

export const ProductSelectDataInitialState: ProductSelectDataState = {
  rawCategories: [],
  rawSuppliers: [],
  hasFetchedCategories: false,
  hasFetchedSuppliers: false,
  searchCategory: {
    productsCategoryOptions: [{ options: [] }],
    isCatOptionsLoading: false,
  },
  searchSuppliers: {
    supplierOptions: [{ options: [] }],
    isSupplierOptionsLoading: false,
  },
};
